import { Authentication } from '@/api'
import Cookies from 'js-cookie'

const api = new Authentication();
export default {

  login({ state }, param) {
    return new Promise((resolve, reject) => {
      api.login(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        Cookies.remove('token');
        Cookies.remove('role');
        Cookies.remove('shopLink');
        
        Cookies.set('token', json.data.token);
        Cookies.set('role', json.data.role);
        Cookies.set('shopLink', json.data.shopLink);
        Cookies.set('redirect',false);
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
  registerThenSendCode({ state, commit, dispatch }, param) {
    return new Promise((resolve, reject) => {
      //  1. Register
      let registerParam = {
        username: param.username,
        password: param.password,
        referralCode: param.referralCode,
        alias: param.alias,
      };

      let sendCodeParam = {
        mobile: param.username,
        region: param.region,
        verificationCode: param.verificationCode,
      };
      let role = Cookies.get('role');
      if ((role == 'K') && (state.AI)) {
        dispatch('sendCode', sendCodeParam).then((SMSJson) => {
          resolve(SMSJson);
        });
      } else {
        dispatch('register', registerParam).then((RegJson) => {
          // console.log(RegJson);
          commit('setAI', { AI: RegJson.data.ID });
          sendCodeParam.ID = RegJson.data.ID;
          dispatch('sendCode', sendCodeParam).then((SMSJson) => {
            resolve(SMSJson);
          });
        })
      }

    })
  },

  verifyMobileThenLogin({ state, getters, dispatch }, param) {
    return new Promise((resolve, reject) => {
      let ID = state.AI;
      let verifyParam = {
        ID: ID,
        verificationCode: param.verificationCode
      };
      let loginParam = {
        username: param.username,
        password: param.password,
      };
      dispatch('verifyMobile', verifyParam).then((VerJson) => {
        dispatch('login', loginParam).then((LoginJson) => {
          resolve(LoginJson);
        });
      })
    })
  },

  register({ state }, param) {
    return new Promise((resolve, reject) => {
      api.register(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
  sendCode({ state, dispatch }, param) {
    return new Promise((resolve, reject) => {
      resolve('108760');
      // api.sendCode(param, (json) => {
      //   if (json.status !== 200) {
      //     reject(json.message);
      //   }
      //   resolve(json);
      // }, (error) => {
      //   reject(error);
      // })
    })
  },
  verifyMobile({ state }, param) {
    return new Promise((resolve, reject) => {
      api.verifyMobile(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    })
  },
  createTmpToken({ state }, parameter) {
    return new Promise((resolve, reject) => {
      let param = {};
      let shopLink = parameter.shopLink;
      if(!shopLink){
        reject('ShopLink not found');
      }
      api.createTmpToken(param,
        (json) => {
          Cookies.set('token',json.data.token);
          Cookies.set('role','C');
          // Cookies.set('shopLink',shopLink);
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },
  forgetPassword({ state }, param) {
    return new Promise((resolve, reject) => {
      api.forgetPassword(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  },
  sendOneTimePassword({ state }, param) {
    return new Promise((resolve, reject) => {
      api.sendOneTimePassword(param, (json) => {
        if (json.status !== 200) {
          reject(json.message);
        }
        resolve(json);
      }, (error) => {
        reject(error);
      })
    });
  },
}



// WEBPACK FOOTER //
// ./src/Auth/store/actions.js